<template>
    <div class="g-modal"></div>
</template>

<script>
export default {
    name: "AppModal"
};
</script>
